interface ThumbsDownIconProps {
  className?: string;
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const ThumbsDownIcon = ({ className = 'w-6 h-6', color = '#5EFAF0' }: ThumbsDownIconProps) => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" className={className}>
    <path
      d="M15.0043 12.6255V1.125C15.0043 0.503681 15.508 1.43051e-06 16.1293 1.43051e-06C16.7506 1.43051e-06 17.2543 0.503681 17.2543 1.125V12.6255C17.2541 13.2466 16.7505 13.7505 16.1293 13.7505C15.5082 13.7505 15.0046 13.2466 15.0043 12.6255Z"
      fill={color}
    />
    <path
      d="M20.0044 9.62549V4.125C20.0044 3.0895 19.1649 2.25005 18.1294 2.25H5.20363C4.2784 2.25 3.49159 2.92499 3.3506 3.83936L2.27248 10.8398C2.09779 11.9754 2.97667 13.0001 4.12551 13.0005H9.12941C9.75069 13.0005 10.2544 13.5042 10.2544 14.1255V18.6255C10.2547 19.3847 10.8707 19.9995 11.6299 19.9995H11.876L15.0884 12.1963L15.1646 12.0454C15.3657 11.7104 15.731 11.5005 16.1299 11.5005H18.1294C19.0999 11.5004 19.8978 10.7625 19.9942 9.81738L20.0044 9.62549ZM22.2544 9.62549L22.2324 10.0474C22.0209 12.1271 20.2649 13.7504 18.1294 13.7505H16.8828L13.9238 20.9341C13.5959 21.7302 12.8205 22.2495 11.9595 22.2495H11.6299C9.62803 22.2495 8.00468 20.6273 8.00441 18.6255V15.2505H4.12551C1.59767 15.2501 -0.335545 12.9956 0.0488467 10.4971L1.12551 3.49805L1.20021 3.12744C1.65277 1.30584 3.29469 -1.67657e-07 5.20363 0H18.1294C20.4075 5.19765e-05 22.2544 1.84686 22.2544 4.125V9.62549Z"
      fill={color}
    />
  </svg>
);
